// extracted by mini-css-extract-plugin
export default {"flex":"Property_flex__CySSF","center":"Property_center__T3bpS","house":"Property_house__5tefx","containerss":"Property_containerss__IGS1k","small":"Property_small__nRPBX"};